import React, { useState } from "react";

const PricingModelInstructions: React.FC = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      <button className="btn btn-outline-secondary btn-sm" onClick={() => setShow(true)}>
        Instructions
      </button>

      {show && (
        <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Product Pricing Models — Instructions</h5>
                <button type="button" className="btn-close" onClick={() => setShow(false)} />
              </div>
              <div className="modal-body">
                <h6>Usage Providers</h6>
                <p>
                  A Usage Provider is a module that calculates product usage for a specified period. It accepts an account ID and date range
                  as inputs and returns a usage value. Every product has at least one Usage Provider, and some products may have multiple providers.
                  For example, Reseller Caller ID Remediation includes one provider that calculates usage for each client account and creates
                  multiple invoice purchases, as well as another provider that consolidates all client accounts into a single purchase.
                </p>

                <h6>Pricing Models</h6>
                <p>
                  A Pricing Model is a module that takes usage as an input and generates four values: Charge, Quantity, Quantity of Data Items,
                  and Purchase Text. The Usage Provider then uses these values to create invoice purchases.
                </p>

                <h6>Creating a Model</h6>
                <p>
                  To set up a billing process for a product/account, you must create a new Pricing Model. To create a model, enter the account ID,
                  select a Usage Provider, and provide the SKU ID. You can leave the account ID blank to apply the model to all accounts.
                  This approach can be useful if you plan to use account attributes to calculate the charge.
                </p>

                <h6>Editing Formulas</h6>
                <p>
                  The next step is to enter JavaScript expressions for Charge, Quantity, Quantity of Data Items, and Purchase Text.
                  Each Pricing Model includes a default tier that you can edit, and you can add additional tiers as needed.
                </p>
                <p>
                  The default tier is useful for simple formulas such as <code>usage * 0.25</code> or{" "}
                  <code>(usage - attribute.IncludedPerMonthReassignedBasicRND) * attribute.OveragePerReassignedBasicRND</code>.
                </p>

                <h6>Tiered Models</h6>
                <p>
                  When creating a tiered model, you can use different formulas for each tier. In this scenario, the default tier can also be helpful.
                  For example, if your Purchase Text is structured as follows:
                </p>
                <pre className="bg-light p-2 rounded"><code>context.clientAcctName + ' (' + context.clientAcctId + ') Caller ID Remediation Daily Scan Add On ' + usage + ' numbers'</code></pre>
                <p>
                  you do not need to repeat it for every tier. Instead, enter it in the default tier and leave the corresponding fields blank in the other tiers.
                </p>

                <h6>Validating</h6>
                <p>Click <strong>Validate Formulas</strong> to check all formulas compile and produce valid results. Errors are highlighted on the corresponding cells.</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setShow(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PricingModelInstructions;
